import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Pipe, inject } from '@angular/core';

@Pipe({
  name: 'bypassSecurityTrustUrl',
  standalone: false,
})
export class BypassSecurityTrustUrl {
  protected sanitizer = inject(DomSanitizer);

  public transform(value: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
}
